import { render, staticRenderFns } from "./Modal_Producto.vue?vue&type=template&id=60b64f8d&scoped=true"
import script from "./Modal_Producto.vue?vue&type=script&lang=js"
export * from "./Modal_Producto.vue?vue&type=script&lang=js"
import style0 from "./Modal_Producto.vue?vue&type=style&index=0&id=60b64f8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b64f8d",
  null
  
)

export default component.exports